import React, { useState, useEffect } from 'react';
import { SeriesOptionsType } from 'highcharts';
import ToolTip from './Tooltip';

export interface GraphLegendProps {
  legend: SeriesOptionsType;
  label?: string;
  variant?: string;
  toggleVisibility: (value: boolean) => void;
  tooltipHelpText?: string;
}

interface VariantProps {
  [key: string]: {
    [key: string]: string;
  };
}

const GraphLegend: React.FC<GraphLegendProps> = ({
  legend,
  label,
  variant,
  toggleVisibility,
  tooltipHelpText
}: GraphLegendProps) => {
  const [visible, setVisible] = useState(true);

  const variantStyles: VariantProps = {
    mainWrapper: {
      default: 'flex items-center mr-[16px] last:mr-0 ',
      scratchpad: 'inline-flex items-center w-max my-[4px] mx-[8px]'
    },
    colorCircle: {
      default: 'bg-gray-50 h-[8px] w-[8px] rounded-full mr-[6px]',
      scratchpad: 'bg-gray-50 h-[16px] w-[16px] rounded-full mr-[6px]'
    },
    label: {
      default: 'text-xs font-nunitoMedium',
      scratchpad:
        'text-[14px] font-nunitoMedium border border-[#E1E1E1] rounded-[24px] pl-[13px] pr-[12px] pt-[3px] pb-[3px]'
    }
  };

  useEffect(() => {
    toggleVisibility(visible);
  }, [visible]);

  return (
    <div
      className={`cursor-pointer ${!variant ? (visible ? `` : `opacity-50`) : ''} ${
        (variant && variantStyles.mainWrapper[variant]) || variantStyles.mainWrapper.default
      }`}
      onClick={() => setVisible(!visible)}
    >
      <div
        className={`${(variant && variantStyles.colorCircle[variant]) || variantStyles.colorCircle.default}`}
        style={{ background: `${legend.color}` }}
      />
      <span
        className={`${(variant && variantStyles.label[variant]) || variantStyles.label.default} ${
          variant === 'scratchpad' ? (visible ? `bg-white` : `bg-[#F3F3F3]`) : ''
        }`}
      >
        {label}
      </span>
      {tooltipHelpText && (
        <>
          <div className="mb-1 pl-1">
            <ToolTip
              data={{
                status: 'HELP',
                message: tooltipHelpText
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default GraphLegend;
